import { render, staticRenderFns } from "./BasePagetop.vue?vue&type=template&id=6c6e55f4&"
import script from "./BasePagetop.vue?vue&type=script&lang=js&"
export * from "./BasePagetop.vue?vue&type=script&lang=js&"
import style0 from "./BasePagetop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports